
































import ProjectInfo from '../components/ProjectInfo.vue';
import Vue from 'vue';
import Project from '@/types/Project';
import {ProjectInfoState as State} from '@/components/types/ProjectInfoState';

export default Vue.extend({
    components: {
        ProjectInfo,
    },

    data() : {
        creationState: State,
        error: string,
        project: Project,
    } {
        return {
            creationState: State.NotStarted,
            error: 'No error',
            project: {
                uid: '',
                username: '',
                name: '',
                description: '',
                genres: [''],
                language: 'assembly',
                arch: 'x1',
                archVersion: 'latest',
            } as Project,
        };
    },

    methods: {
        handleSubmit(project: Project) {
            this.creationState = State.Saving;
            this.$store.dispatch('project/create', project)
                .then(() => {
                    this.creationState = State.Done;
                    this.$router.push(`/editor/${this.$store.state.project!.projectDef!.id}`);
                })
                .catch((e) => {
                    this.error = e.message;
                    this.creationState = State.Error;
                });
        },

        cancel() {
            this.$router.push('/');
        },
    },
});
